import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=3b387531&scoped=true&"
import script from "./contact.js?vue&type=script&lang=js&"
export * from "./contact.js?vue&type=script&lang=js&"
import style0 from "./contact.css?vue&type=style&index=0&id=3b387531&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b387531",
  null
  
)

export default component.exports